import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AuthGuard } from './guards/auth.guard';
import { AppRoutingModule } from './routing/app-routing';

import { AudienceService } from './services/audience.service';
import { AuthenticationService } from './services/authentication.service';

import { AppComponent } from './app.component';
import { AudiencesComponent } from './audiences/audiences.component';
import { AudienceComponent } from './audience/audience.component';
import { AudienceheaderComponent } from './audienceheader/audienceheader.component';
import { LoginComponent } from './login/login.component';
import { AboutComponent } from './about/about.component';

@NgModule({
  declarations: [
    AppComponent,
    AudiencesComponent,
    AudienceComponent,
    AudienceheaderComponent,
    LoginComponent,
    AboutComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule
  ],
  providers: [
    AuthGuard,
    AudienceService,
    AuthenticationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts